import React from 'react';
import { Redirect } from 'react-router-dom';
import PropTypes from 'prop-types';
import cookies from 'react-cookies';
import Grid from '@material-ui/core/Grid';
import { LOGIN_URL } from 'src/constants/constants.js';
import intl from 'react-intl-universal';

export const LoginLayout = props => {
  const cook = cookies.load('HashCookie');
  const { children } = props;
  return props.skipAuth || cook ? (
    <div>
      <div className="row">
        <div className="header-logo" />
      </div>
      <div>
        <div className={`header-image`}>
          <div className="iso">
            <div className="dots">
              <span className="square" />
              <span className="square" />
              <span className="square" />
            </div>
            <div className="legend">{intl.get('login.eyTitle')}</div>
          </div>
          <div className="baseline" />
        </div>
      </div>
      <div>
        <div className={`login_content`}>
          <Grid container spacing={24} classes={{ container: '' }}>
            {children}
          </Grid>
        </div>
      </div>
    </div>
  ) : (
    <Redirect to={LOGIN_URL} />
  );
};

LoginLayout.propTypes = {
  skipAuth: PropTypes.bool,
};

LoginLayout.defaultProps = {
  skipAuth: false,
};

export default LoginLayout;



// WEBPACK FOOTER //
// ./src/ui/features/Login/presentational/layout/LoginLayoutPres.js